/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Routes, useLocation } from 'react-router';

import { SkipNavContent, ErrorBoundary } from 'sarsaparilla';

import { ExternalPageFrame } from 'shared-ui/external-app-base';
import ErrorPage from 'shared-ui/components/ErrorPage/ErrorPage';
import { TopNavigationExternal } from 'shared-ui/TopNavigationExternal';
import SearchDebugPage from '../src/containers/SearchDebugPage';
import makeSwitchRoutes from './makeSwitchRoutes';

export default function App() {
    const location = useLocation();

    if (location.pathname === '/search/debug') {
        return <SearchDebugPage />;
    }

    return (
        <ExternalPageFrame>
            <TopNavigationExternal />

            <ErrorBoundary fallbackElement={<ErrorPage />}>
                <SkipNavContent role="main" className="rec-page">
                    <Routes>{makeSwitchRoutes()}</Routes>
                </SkipNavContent>
            </ErrorBoundary>
        </ExternalPageFrame>
    );
}
